// extracted by mini-css-extract-plugin
export default {"container":"kM-z","error":"lM-z","disabled":"mM-z","submit":"nM-z","option":"oM-z","success":"pM-z","failure":"qM-z"};